<script setup lang="ts">
import { type NavigationNode } from '~/layouts/navigation'
import type { CommandItem } from '../CommandPalette.vue'
import { ComboboxOption } from '@headlessui/vue'

const props = defineProps<{
  query: string
  navigationItems: NavigationNode[]
}>()

const flattenedItems = computed(() => {
  const flattenItems = (
    items: NavigationNode[],
    parentName = '',
  ): CommandItem[] => {
    return items.reduce((acc, item) => {
      const fullName = parentName ? `${parentName} > ${item.name}` : item.name
      const current: CommandItem = {
        id: item.to || fullName,
        name: fullName,
        description: `Navigate to ${item.name}`,
        icon: item.icon,
        to: item.to,
      }

      if (item.children) {
        return [...acc, current, ...flattenItems(item.children, item.name)]
      }

      return [...acc, current]
    }, [] as CommandItem[])
  }

  return flattenItems(props.navigationItems)
})

const items = computed(() => {
  return flattenedItems.value.filter(
    (item) =>
      item.name.toLowerCase().includes(props.query) ||
      item.description.toLowerCase().includes(props.query),
  )
})
</script>
<template>
  <div class="px-4 py-4 bg-gray-50 text-xs font-medium text-gray-500 uppercase d">
    Navigation items
  </div>

  <ComboboxOption
    v-if="items.length"
    v-for="item in items"
    :key="item.id"
    :value="item"
    v-slot="{ active }"
    as="template"
  >
    <CommandPaletteItem :item="item" :active="active" />
  </ComboboxOption>
  <CommandPaletteMessagesNothingFound v-else-if="query.length" />
</template>
